module.exports = {"semester-start-date":"1/19/2021","semester-end-date":"5/14/2021","active":true}